import LifeAndLeaveEnrollment from "./life-and-leave";

const LIFE_AND_LEAVE_ENROLLMENT_PATH = "/life-and-leave/enrollment";

export { LifeAndLeaveEnrollment, LIFE_AND_LEAVE_ENROLLMENT_PATH };
